<template>
  <div class="pe_slideout">
    <button 
      class="pe_btn pe_menu"
      :class="[getGameTypeBtnClass]"
      @click="onMenuOpen"
    >
      <!--<span></span>
      <span></span>
      <span></span>-->
      Menu
    </button>

    <div 
      class="pe_slideout-menu-wrap" 
      
      v-show="menuIsOpen"
      @click="onMenuClose"
    >
    
      <transition name="slide" mode="out-in">
        <div 
          v-show="menuIsOpen"
          class="pe_slideout-menu" 
          @click.stop
        >
          <header :class="[ this.gType ]">
            <h2 :class="[ this.gType ]">Menu</h2>
            <button 
              class="pe_btn"
              @click="onMenuClose"
            >
              <close-icon 
                @click="onMenuClose"
              />
            </button>
          </header>

          <button 
            class="pe_btn" 
            v-if="this.gType !== 'trivia'"
            @click="clickReset()"
          >
            Reset Puzzle
          </button>

         <!-- <button 
            class="pe_btn" 
            v-if="this.gType === 'trivia'"
            @click="clickTriviaReset()"
          >
            Reset Trivia Puzzle
          </button>-->

          <router-link 
            v-if="!isHome"
            :to="'/'"
            class="pe_btn"
          > 
            Main Menu
          </router-link>

          <router-link 
            to="/archive"
            class="pe_btn"
            v-if="showPreviousPuzzlesLink"
          > 
            Play Previous Puzzles
          </router-link>

          <hr>
          
          <h3>Options</h3>
          
          <ToggleSwitch 
            label="Show Timer"
            :model="showTimer"
            @changed="setShowTimer($event)"
            TooltipText="Shows or hides the timer"
          />
          

          <ToggleSwitch 
            v-if="gameMode === 'quick' && showVisualGuides"
            label="Visual Guides"
            :model="visualGuides"
            @changed="setVisualGuides($event)"
            TooltipText="Shades cells to indicates when entry is correct"
          />          

          <ToggleSwitch 
            v-if="gameMode === 'quick'"
            label="Allow Hints"
            :model="allowHints"
            @changed="setAllowHints($event)"
            class="pe_allow-hints"
            TooltipText="Shows or hides the hint button"
          />

          <ToggleSwitch 
            v-if="gType === 'crossword' "
            label="Jump Mode"
            :model="crosswordJumpToBlank"
            @changed="setCrosswordJumpToBlank($event)"
            TooltipText="Active cell will jump over letters already entered"
          />
          
          <hr>

          <!--<button class="pe_btn" @click="openThemeModal">Themes</button> 
          <hr>
          <button class="pe_btn" @click="openPuzzleGuide">Puzzle Guide</button>-->
          <button class="pe_btn" @click="openSupportModal">Feedback Form</button>
          
        </div>
      </transition>
    </div>

    <SupportTicketModal 
      v-if="supportModal"
      @close="closeSupportModal"
    />

    <PuzzleGuide
      v-if="puzzleGuide"
      @close="closePuzzleGuide">

    </PuzzleGuide>

    <Modal 
      v-if="themeModal" 
      @close="closeThemeModal"
    >
      <template v-slot:title>Choose a theme:</template>
      <template v-slot:body>
        <button 
          v-for="(val, theme) in themes"
          :key="`t-btn-${theme}`"
          @click="selectTheme(theme)"
          class="pe_btn pe_theme-color"
        >
          <span
            :style="(theme === selectedTheme) ? 'font-weight: 900;' : ''"
          >
            {{ theme }}
          </span>
          <div 
            class="pe_box"
            :style="`background: ${ themes[theme].display };`"
          ></div>
        </button>
      </template>
      <template v-slot:footer>Select Theme</template>
    </Modal>

  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

import Modal from './Modal'
import SupportTicketModal from './SupportTicketModal2'
import PuzzleGuide from './PuzzleGuide'
import Cross from '@puzzleapps/shared/src/components/ui/icons/Cross'
import ToggleSwitch from './ToggleSwitch'

export default {  
  components: {
    ToggleSwitch,
    SupportTicketModal,
    Modal,
    PuzzleGuide,
    'close-icon': Cross
  },

  data () {
    return {
      themeModal: false,
      supportModal: false,
      menuIsOpen: false,
      clientId: null,
      jumpModeValue: false,
      puzzleGuide: false,
    }
  },

  mounted() {
    this.clientId = window.PE_CLIENTAPP_ID

  },
  created(){
    //this.setShowTimerFromLocal
    this.setStateVariablesFromLocal //sets the jumpmodestatus in state from local storage
  },

  computed: {
    ...mapState({
      themes: state => state.userSettings.themes,
      selectedTheme: state => state.userSettings.selectedTheme,
      isPlaying: state => state.game.isPlaying,
      titleHtml: state => state.game.titleHtml,
      gameMode: state => state.userSettings.gameMode,
      showTimer: state => state.userSettings.showTimer,
      allowHints: state => state.userSettings.allowHints,
      visualGuides: state => state.userSettings.visualGuides,
      hintsUsed: state => state.game.hintsUsed,
      gameType: state => state.game.gameType,
      gType: state => state.game.type,
      TriviaCatID: state => state.game.puzzleId,
      crosswordJumpToBlank: state => state.userSettings.crosswordJumpToBlank,
      appId: state => state.game.appId,
      compID: state => state.game.competitionID,
    }),

    isHome() {
      return this.$route.name === 'Home'
    },
    getGameTypeBtnClass(){
        return "pe_menu_btn-" + this.gType
    },
    showVisualGuides(){
      return this.gType === 'crossword' ? true : this.gType === 'sudoku' ? true : this.gType === 'codecracker' ? true : false
    },

    setStateVariablesFromLocal(){
      this.setStateSettingsToLocal();
    },

    showPreviousPuzzlesLink(){
      return this.gType === 'trivia' ? false : this.compID !== 0 ? false : true
    }

  },

  methods: {

    ...mapActions({
      setIsPlaying: 'game/setIsPlaying',
      resetPuzzle: 'game/resetPuzzle',
      resetTrivia: 'game/resetTrivia',
      selectTheme: 'userSettings/selectTheme',
      setShowTimer: 'userSettings/setShowTimer',
      setAllowHints: 'userSettings/setAllowHints',
      setVisualGuides: 'userSettings/setVisualGuides',
      setCrosswordJumpToBlank: 'userSettings/setCrosswordJumpToBlank',
      goToPuzzleRoute: 'game/goToPuzzleRoute',
      getTriviaHiScoreFromLocal : 'game/getTriviaHiScoreFromLocal',

      setStateSettingsToLocal: 'userSettings/setStateSettingsToLocal',
      deselectCells: 'grid/deselectAllCells',
    }), 

    onMenuOpen() {
      this.setIsPlaying(false) //set to false to hide the clues etc when clicked
      this.menuIsOpen = true
    },

    onMenuClose() {
      this.setIsPlaying(true)
      this.menuIsOpen = false
    },

    closeThemeModal() {
      this.setIsPlaying(true)
      this.menuIsOpen = false
      this.themeModal = false
    },

    openThemeModal() {
      this.setIsPlaying(false)
      this.menuIsOpen = false
      this.themeModal = true
    },

    closeSupportModal() {
      
      this.setIsPlaying(true)
      this.menuIsOpen = false
      this.supportModal = false
    },

    openSupportModal() {
      this.setIsPlaying(false)
      this.menuIsOpen = false
      this.supportModal = true
      this.deselectCells()
    },

    closePuzzleGuide() {
      this.setIsPlaying(true)
      this.menuIsOpen = false
      this.puzzleGuide = false
    },

    openPuzzleGuide() {
      this.setIsPlaying(false)
      this.menuIsOpen = false
      this.puzzleGuide = true
    },

    clickReset() {
      if(confirm('Are you sure you want to reset? You will lose all progress if you do')){
        this.resetPuzzle()
        this.menuIsOpen = false

      }
        
    },
    clickTriviaReset() {
      let id = this.TriviaCatID

      this.resetTrivia()
      this.getTriviaHiScoreFromLocal(id);

      this.goToPuzzleRoute({ router: this.$router, id }) // this way of doing it doesn't work
      this.menuIsOpen = false
    },

    

  },



}
</script>

<style scoped lang="scss">

#puzzleapp {

  .slide-leave-active,
  .slide-enter-active {
    transition: 0.3s;
  }
  .slide-enter {
    transform: translate(100%, 0);
  }
  .slide-leave-to {
    transform: translate(-100%, 0);
  }

  .pe_slideout-menu-wrap {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50;
    background: rgba(0,0,0,0.2);
  }

  .pe_slideout-menu {
    position: absolute;
    width: 260px;
    max-width: 100%;
    top: 0;
    right: 0;
    height: 100%;
    background: var(--secondary-background-color);
    z-index: 60;
    overflow: auto;

    h3 {
      font-size: 1.1em!important;
      text-align: center;
      margin-bottom: 0.6em;
      margin-top: 0.6em;
    }

    @media (max-width: 500px) {
      width: 100%;
    }

    header {
      background: var(--secondary-background-color);
      margin: 0;
      height: 2.8em;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1em;
        &.crossword{
          background: var(--crossword-menu-btn-background);
        }
        &.sudoku{
          background: var(--sudoku-menu-btn-background);
        }
        &.codecracker{
          background: var(--codecracker-menu-btn-background);
        }
        &.wordsearch{
          background: var(--wordsearch-menu-btn-background);
        }

      .pe_btn {
        width: 28px;
        height: 28px;
        position: absolute;
        right: 12px;
        padding: 0;
        color: var(--default-font-color);
      }
      .pe_cross {
        width: 15px;
        height: 15px;
        cursor: pointer;
        padding: 4px;
      }

      h2 {
        margin: 0;
        font-size: 1.2em;
        &.crossword{
          color: var(--crossword-menu-btn-color)!important;
        }
        &.sudoku{
          color: var(--sudoku-menu-btn-color)!important;
        }
        &.codecracker{
          color: var(--cdecracker-menu-btn-color)!important;
        }

        &.wordsearch{
          color: var(--wordsearch-menu-btn-color)!important;
        }
      }
    
    }

    .pe_btn {
      width: 100%;
      margin: 0;
      font-size: 0.9em;
      color: var(--default-font-color);
    }
  }
  .pe_btn.pe_menu {
    //width: 2em;
    //height: 2.5em;
    //padding: 0.1em;
    top: 0.2em;
    display: inline-block;
    @media (min-width: 850px) {
    width: 7vw;
    min-width: 40px;
    
    }
    &.pe_menu_btn-crossword{
      background: var(--crossword-menu-btn-background);
      
      color: var(--crossword-menu-btn-color);
      height: 100%;
      /*&:hover {
        background: var(--crossword-menu-btn-hover);
      }*/
    }
    &.pe_menu_btn-sudoku{
      background: var(--sudoku-menu-btn-background);
      
      color: var(--sudoku-menu-btn-color);
      height:100%;
      &:hover {
        background: var(--sudoku-menu-btn-hover);
      }
    }
    &.pe_menu_btn-codecracker{
      background: var(--codecracker-menu-btn-background);
      
      color: var(--codecracker-menu-btn-color);
      height:100%;
      &:hover {
        background: var(--codecracker-menu-btn-hover);
      }
    }
    &.pe_menu_btn-wordsearch{
      background: var(--wordsearch-menu-btn-background);
      
      color: var(--wordsearch-menu-btn-color);
      height:100%;
      &:hover {
        background: var(--wordsearch-menu-btn-hover);
      }
    }
    &.pe_menu_btn-trivia{
      background: var(--trivia-menu-btn-background);
      
      color: var(--trivia-menu-btn-color);
      height:100%;
      &:hover {
        background: var(--trivia-menu-btn-hover);
      }
    }

    span {
      display: block;
      height: 2px;
      width: 100%;
      background: var(--default-font-color);
      
      &:not(:last-child) {
        margin-bottom: 6px;
      }
    }
  }

  .pe_toggle-switch {
    padding: 0.5em;
    max-width: 13em;
    margin: auto;
  }
  
  .pe_btn.pe_theme-color {
    margin: auto!important;
    width: 160px;
    display: flex;
    justify-content: space-between;
    text-transform: capitalize;
      
    .pe_box {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 1px solid #a2a2a2;
    }
  }
}


</style>